import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  showingNavMenu: '',
  breakpoint: '',
};

const layoutSlice = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    layoutShowingNavMenu(state, action) {
      state.showingNavMenu = action.payload;
    },
    setBreakpoint(state, action) {
      state.breakpoint = action.payload;
    },
  },
});
export const { layoutShowingNavMenu, setBreakpoint } = layoutSlice.actions;
const layoutReducer = layoutSlice.reducer;

export default layoutReducer;
